<template>
  <div class="app-container">
    <el-descriptions title="订单信息" :column="4">
      <el-descriptions-item label="订单编号" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ tblRecycleOrder.orderNum }}</el-descriptions-item>
      <el-descriptions-item label="订单金额" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ tblRecycleOrder.actualPrice || '--' }}</el-descriptions-item>
      <el-descriptions-item label="旧机品类" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ tblRecycleCommodity.spmc }}</el-descriptions-item>
      <el-descriptions-item label="订单状态" :labelStyle="labelStyle" :contentStyle="contentStyle">
        {{ orderStateStrFun(tblRecycleOrder.orderState) }}
      </el-descriptions-item>
      <el-descriptions-item label="订单创建时间" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ tblRecycleOrder.createdDate }}</el-descriptions-item>
      <el-descriptions-item label="订单完成时间" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ tblRecycleOrder.completedDate }}</el-descriptions-item>
      <el-descriptions-item label="回收地址" :labelStyle="labelStyle" :contentStyle="contentStyle">
        {{ tblRecycleOrder.sfen }}-{{ tblRecycleOrder.cshi }}-{{ tblRecycleOrder.xian }}-{{ tblRecycleOrder.xzhen }} -{{ tblRecycleOrder.dizi }}
        <span v-if="tblRecycleOrder.dizi">
            <img v-if="!dataVisible.dizi" src="@/assets/eye-close.png" @click="toggleVisibility('dizi')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('dizi')" />
          </span>
      </el-descriptions-item>
      <el-descriptions-item label="合作方" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ userBill.payAccountName }}</el-descriptions-item>
      <el-descriptions-item label="联系人" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ tblRecycleOrder.yhmc }}</el-descriptions-item>
      <el-descriptions-item label="联系电话" :labelStyle="labelStyle" :contentStyle="contentStyle"
        >{{ tblRecycleOrder.yddh }}
        <span v-if="tblRecycleOrder.yddh">
            <img v-if="!dataVisible.yddh" src="@/assets/eye-close.png" @click="toggleVisibility('yddh')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('yddh')" />
          </span>
      </el-descriptions-item>
    </el-descriptions>

    <el-descriptions title="账单信息" :column="4" style="margin-top: 20px;">
      <el-descriptions-item label="账单编号" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ userBill.billNo }}</el-descriptions-item>
      <el-descriptions-item label="交易流水号" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ userBill.payNo }}</el-descriptions-item>
      <el-descriptions-item label="申请类型" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ userBill.requestType == 1 ? '冻结' : '提现' }}</el-descriptions-item>
      <el-descriptions-item label="资金类型" :labelStyle="labelStyle" :contentStyle="contentStyle">
        {{ userBill.expenseType == 1 ? '旧机费用' : '推荐费用' }}
      </el-descriptions-item>
      <el-descriptions-item label="申请金额" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ userBill.amount }}</el-descriptions-item>
      <el-descriptions-item label="申请时间" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ formatDateTime(userBill.applyDate) }}</el-descriptions-item>
      <el-descriptions-item label="到账时间" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ formatDateTime(userBill.accountDate) }}</el-descriptions-item>
      <el-descriptions-item label="收款人" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ userBill.receiverAccountName }}</el-descriptions-item>
      <el-descriptions-item label="收款账号" :labelStyle="labelStyle" :contentStyle="contentStyle"
        >{{ userBill.receiverAccountNo }}
        <span v-if="userBill.receiverAccountNo">
            <img v-if="!dataVisible.receiverAccountNo" src="@/assets/eye-close.png" @click="toggleVisibility('receiverAccountNo')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('receiverAccountNo')" />
          </span>
      </el-descriptions-item>
      <el-descriptions-item label="处理状态" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ dealStatusStrFun(userBill.dealStatus) }}</el-descriptions-item>
      <el-descriptions-item label="失败原因" :labelStyle="labelStyle" :contentStyle="contentStyle">{{ userBill.reason }}</el-descriptions-item>
    </el-descriptions>
    <div style="text-align: center; margin-top: 20px;">
      <el-button @click="$router.back(-1)">返回</el-button>
    </div>
  </div>
</template>
<script>
import { dealStatusList, expenseTypeList, requestTypeMap, dealStatusMap, orderStateMap, expenseTypeMap } from './paymentEnums'
import dayjs from 'dayjs'
export default {
  name: 'orderDetail',
  data() {
    return {
      userBill: {},
      tblRecycleOrder: {},
      tblRecycleCommodity: {},
      labelStyle: {
        'font-size': '14px',
        'font-weight': '400',
        'text-align': 'left',
        color: '#9d9d9d'
      },
      contentStyle: {
        'font-size': '14px',
        'font-weight': '400',
        'text-align': 'left',
        color: '#333'
      },
      originUserBill:{},
      originTblRecycleOrder:{},
      dataVisible:{
        yddh: false,
        dizi:false,
        receiverAccountNo: false
      },
      yddh:'',
      dizi:'',
      receiverAccountNo:''
    }
  },
  methods: {
    getDetail(billNo) {
      this.HttpService.get(`/autoapp-default-server-recovery/api/userBill/detailById/${billNo}`).then(res => {
        if (res.statusCode === 200) {
          this.userBill = res.data.userBill
          this.originUserBill = res.data.userBill ? {...res.data.userBill}:{}
          this.tblRecycleOrder = res.data.tblRecycleOrder
          this.originTblRecycleOrder = res.data.tblRecycleOrder ? {...res.data.tblRecycleOrder} : {}
          this.tblRecycleCommodity = res.data.tblRecycleCommodity

            // 根据 sensitizationCode 拆分数据
        if (res.data.desensitizationDtoList && Array.isArray(res.data.desensitizationDtoList)) {
          const phoneMappings = {
            yddh_phone: 'yddh',
            dizi_address: 'dizi',
            receiverAccountNo_bankCard: 'receiverAccountNo',
          }

          res.data.desensitizationDtoList.forEach(item => {
            const targetProperty = phoneMappings[item.sensitizationCode]
            if (targetProperty) {
              this[targetProperty] = {
                sensitizationCode: item.sensitizationCode,
                message: item.message
              }
            }
          })
        }
        }
      })
    },
    orderStateStrFun(type) {
      return orderStateMap[type] || ''
    },
    dealStatusStrFun(type) {
      return dealStatusMap[type] || ''
    },
    formatDateTime(date) {
      if (!date) {
        return ''
      }
      const parsedDate = dayjs(date)
      return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DD HH:mm:ss') : ''
    },

    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    toggleVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'yddh':
          if (this.dataVisible.yddh && this.yddh.message) {
            this.getSourceOrigin(this.yddh).then(res => {
              this.$set(this.tblRecycleOrder, 'yddh', res)
            })
          } else if (!this.dataVisible.yddh) {
            // 还原为原始脱敏数据
            this.$set(this.tblRecycleOrder, 'yddh', this.originTblRecycleOrder.yddh)
          }
          break
        case 'dizi':
          if (this.dataVisible.dizi && this.dizi.message) {
            this.getSourceOrigin(this.dizi).then(res => {
              this.$set(this.tblRecycleOrder, 'dizi', res)
            })
          } else if (!this.dataVisible.dizi) {
            // 还原为原始脱敏数据
            this.$set(this.tblRecycleOrder, 'dizi', this.originTblRecycleOrder.dizi)
          }
          break
        case 'receiverAccountNo':
          if(this.dataVisible.receiverAccountNo && this.receiverAccountNo.message){
            this.getSourceOrigin(this.receiverAccountNo).then(res => {
              this.$set(this.userBill, 'receiverAccountNo', res)
            })
          } else if (!this.dataVisible.receiverAccountNo) {
            // 还原为原始脱敏数据
            this.$set(this.userBill, 'receiverAccountNo', this.originUserBill.receiverAccountNo)
          }
      }
    }
  },
  mounted() {
    this.getDetail(this.$route.query.billNo)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/paymentManagement/orderDetail.vue